import { createRouter, createWebHashHistory } from "vue-router";
import ArticleDetail from "@views/ArticleDetail.vue";
import Search from "@views/Search.vue";

export const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/articledetail",
      component: ArticleDetail,
      name: "articledetail",
      meta: {
        moduleName: "articledetail",
        modulePaht: "/articledetail",
      },
    },
    {
      path: "/search",
      component: Search,
      name: "search",
      meta: {
        moduleName: "search",
        modulePaht: "/search",
      },
    },
  ],
});
